import React from "react";
import { Button, Dialog, DialogActions, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import DeleteSweepOutlinedIcon from "@mui/icons-material/DeleteSweepOutlined";
import { MUTED, cancelSx, dialogStyles as styles, submitSx } from "./dialogStyles";

// The red look for an action that throws work away and cannot be undone.
const DANGER = "#DC3545";
const dangerBadge = { backgroundColor: "#FDECEC", color: DANGER };
const dangerButtonSx = {
  ...submitSx,
  backgroundColor: DANGER,
  "&:hover": { backgroundColor: "#B02A37" },
};

// The app's confirmation dialog, in place of the browser's confirm(): same
// look as its form dialogs. `tone="danger"` is for destructive actions.
// Escape, the close button and Cancel all call onCancel.
function ConfirmDialog({
  open,
  title,
  message,
  details,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  tone = "default",
  icon,
  onConfirm,
  onCancel,
}) {
  const danger = tone === "danger";
  const Icon = icon ?? (danger ? DeleteSweepOutlinedIcon : HelpOutlineIcon);

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth
      maxWidth="xs"
      PaperProps={{ sx: { borderRadius: "16px" } }}
      aria-labelledby="confirm-dialog-title"
    >
      <div style={{ ...styles.header, borderBottom: "none", paddingBottom: "8px" }}>
        <div style={{ ...styles.badge, ...(danger && dangerBadge) }}>
          <Icon />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div id="confirm-dialog-title" style={styles.title}>
            {title}
          </div>
          {message && (
            <div style={{ ...styles.subtitle, fontSize: "14px", marginTop: "6px", lineHeight: 1.5 }}>
              {message}
            </div>
          )}
        </div>
        <IconButton onClick={onCancel} size="small" sx={{ color: MUTED }} aria-label="Close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>

      {details && (
        <DialogContent sx={{ padding: "4px 24px 8px 82px", fontFamily: "manrope", fontSize: "13px" }}>
          {details}
        </DialogContent>
      )}

      <DialogActions sx={{ padding: "12px 24px 20px", gap: "4px" }}>
        <Button onClick={onCancel} sx={cancelSx}>
          {cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          disableElevation
          autoFocus
          sx={danger ? dangerButtonSx : submitSx}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDialog;
